import { useFormField } from "../useFormField.js";
/**
 * Handles props for Fieldset in context with parent Fieldset.
 */
export const useFieldset = (props) => {
    const formField = useFormField(props, "fieldset");
    const { inputProps } = formField;
    return Object.assign(Object.assign({}, formField), { inputProps: {
            "aria-invalid": inputProps["aria-invalid"],
            "aria-describedby": inputProps["aria-describedby"],
        } });
};
//# sourceMappingURL=useFieldset.js.map